import * as ACTIONS from "@iso/redux/forWhoMessages/actionTypes";

const initialState = {
  forWhoMessages: {
    list: [],
    total: 0,
  },
};

function forWhoMessagesReducer(state = initialState, action) {
  const { payload, type } = action;

  switch (type) {
    case ACTIONS.GET_FOR_WHO_MESSAGES_SUCCESS: {
      return {
        ...state,
        ...{ forWhoMessages: payload },
      };
    }

    default:
      return state;
  }
}

export default forWhoMessagesReducer;
